import { Icon, IconName } from "@nju/icons";
import { Separator, Text } from "@nju/ui";

interface ITitleProps {
  title: string;
  iconName: IconName;
}

export function Title({ title, iconName }: ITitleProps) {
  return (
    <>
      <div className="flex items-center gap-2">
        <Icon
          className="w-5 h-5 from-tablet:w-6 from-tablet:h-6"
          name={iconName}
          tone="accent"
        />
        <Text
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "xl",
          }}
          weight="bold"
        >
          {title}
        </Text>
      </div>
      <Separator size="l" thickness="medium" tone="accent" />
    </>
  );
}
